export enum AuthorLayout {
  Large,
  Regular,
}
